export default __webpack_public_path__ + "static/Crianca-bicicleta-2dba5789b775af63d9e2c9eae0341000.jpg";